module.exports = function getResource(label, vars=[]) {
    const resources = {
        getItShippedTitle: 'Faites livrer',
        shippingAndReturns: 'Livraison et retours',
        reserveAndPickUp: 'Réservation et ramassage',
        buyOnlineAndPickUp: 'Achat en ligne et ramassage',
        selectForStoreAvailability: 'Sélectionner pour voir la disponibilité',
        limitedStock: 'Quantités limitées',
        outOfStock: 'Rupture de stock',
        inStock: 'En stock',
        stores: 'magasins',
        nearYou: 'près de chez vous',
        checkOtherStores: 'Voir les autres magasins',
        notOffered: 'Réservation non offerte dans ce magasin',
        pickUpNotOffered: 'Le ramassage n’est pas offert dans ce magasin',
        atThisStore: 'dans ce magasin',
        availableInAllStores: 'Offert dans tous les magasins',
        onlineOnly: 'En ligne seulement',
        reserveNotAvailable: 'Option Réservation et ramassage non offerte',
        pickUpNotAvailable: 'Option Achat en ligne et ramassage non offerte',
        reservationNotOfferedForItem: 'Réservation non offerte pour cet article',
        pickUpNotOfferedForItem: 'Le ramassage n’est pas offert pour cet article',
        at: 'à',
        for: 'pour',
        sameDayDelivery: 'Livraison le jour même',
        standard: 'Standard',
        sameDayDeliveryNotAvailable: 'Non disponible pour cet article',
        sddTemporarilyUnavailableAtLocation: 'La livraison le jour même n’est pas disponible pour le moment. Veuillez réessayer plus tard.',
        sameDayNotAvailableFor: 'La livraison le jour même n’est pas disponible',
        yourLocation: 'votre emplacement',
        changeLocation: 'Changer votre emplacement',
        autoReplenishTitle: 'Réapprovisionnement automatique',
        deliveryEvery: 'Livraison chaque',
        months: 'mois',
        mostCommon: 'le plus courant',
        subscriptionNotAvailable: 'Non disponible pour cette sélection',
        save: 'Enregistrer',
        rougeMemberYouGet: 'En tant que membre Rouge, vous pouvez aussi essayer',
        rougeMemberFreeSameDayDelivery: 'gratuitement la livraison le jour même',
        autoReplenishLegalOptIn: 'En vous inscrivant, vous consentez aux frais récurrents de votre abonnement.',
        freeShipSignIn: `${vars[0]} ou ${vars[1]} pour profiter de ${vars[2]}.`,
        signIn: 'Ouvrir une session',
        createAccount: 'créer un compte',
        freeStandardShipping: 'Livraison standard GRATUITE',
        storesNearYou: 'magasins près de chez vous',
        inStorePickup: 'Ramassage en magasin',
        curbsidePickup: 'Ramassage à l’extérieur',
        curbsideConcierge: 'Concierge pour ramassage à l’extérieur',
        aboutSameDayDelivery: 'À propos de la livraison le jour même',
        notAvailable: 'Non disponible',
        sddRougeFreeShipMessage: 'En tant que membre Rouge, vous pouvez aussi essayer gratuitement la livraison le jour même!',
        aboutBuyOnlineAndPickUp: 'À propos de l’option Achetez en ligne et ramassez',
        aboutAutoReplen: 'À propos du réapprovisionnement automatique',
        sddRougeTestV2Message: `En tant que membre Rouge, vous êtes à ${vars[0]} de pouvoir profiter de la livraison le jour même GRATUITE.`,
        sddRougeTestV2FreeShippingMessage: 'En tant que membre Rouge, vous pouvez essayer la livraison le jour même GRATUITE.',
        wantFreeShipping: 'Want free shipping?',
        signInToGetIt: 'Sign in to get it - and more.',
        testSignInButton: 'Sign In',
        testCreateAccountButton: 'Create an Account',
        or: 'or',
        autoReplenishSubTitle: 'Save 5% on this item'
    };

    return resources[label];
};
